import './project-row.styl'
import React from 'react'
import { Row, Col } from 'react-bootstrap'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    let { project, click, active } = this.props

    if (typeof click !== 'function') {
      click = () => {}
    }

    let classNames = 'project-row'

    if (project.disabled) {
      classNames += ' disabled'
    }

    if (!project.disabled && active) {
      classNames += ' active'
    }

    return (
      <div className={classNames} onClick={ (e) => { click(e) } }>
        <Row>
          <Col xs={9}>{ project.name }</Col>
          <Col xs={3} className="align-right"><i className="fa fa-chevron-right" /></Col>
        </Row>
      </div>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Projects/project-row.js